import adminRoutes from 'common/routes/adminRoutes';
import authRoutes from 'common/routes/authRoutes';
import availabilityRoutes from 'common/routes/availabilityRoutes';
import clientRoutes from 'common/routes/clientRoutes';
import exerciseRoutes from 'common/routes/exerciseRoutes';
import gamificationRoutes from 'common/routes/gamificationRoutes';
import mealPlanRoutes from 'common/routes/mealPlanRoutes';
import newsRoutes from 'common/routes/newsRoutes';
import notificationRoutes from 'common/routes/notificationRoutes';
import nutritionRoutes from 'common/routes/nutritionRoutes';
import orgClientRoutes from 'common/routes/orgClientRoutes';
import paymentRoutes from 'common/routes/paymentRoutes';
import performanceRoutes from 'common/routes/performanceRoutes';
import planRoutes from 'common/routes/planRoutes';
import playRoutes from 'common/routes/playRoutes';
import pqrsRoutes from 'common/routes/pqrsRoutes';
import legalRoutes from 'common/routes/legalRoutes';
import progressRoutes from 'common/routes/progressRoutes';
import sessionRoutes from 'common/routes/sessionRoutes';
import sessionTypeRoutes from 'common/routes/sessionTypeRoutes';
import supervisorRoutes from 'common/routes/supervisorRoutes';
import trainerRoutes from 'common/routes/trainerRoutes';
import userRoutes from 'common/routes/userRoutes';

const routes = {
  ...adminRoutes,
  ...authRoutes,
  ...availabilityRoutes,
  ...clientRoutes,
  ...exerciseRoutes,
  ...gamificationRoutes,
  ...legalRoutes,
  ...mealPlanRoutes,
  ...newsRoutes,
  ...notificationRoutes,
  ...nutritionRoutes,
  ...orgClientRoutes,
  ...paymentRoutes,
  ...performanceRoutes,
  ...planRoutes,
  ...playRoutes,
  ...pqrsRoutes,
  ...progressRoutes,
  ...sessionRoutes,
  ...sessionTypeRoutes,
  ...supervisorRoutes,
  ...trainerRoutes,
  ...userRoutes
};

export default routes;
